import { inject, ref } from 'vue';

export const useOrbit = () => {
    const orbit = inject('orbit', ref(false));

    return orbit;
};
